__turbopack_context__.v({
  "addToCartButton": "ProductCard-module-scss-module__RFMiWq__addToCartButton",
  "blue": "ProductCard-module-scss-module__RFMiWq__blue",
  "buttonContainer": "ProductCard-module-scss-module__RFMiWq__buttonContainer",
  "cardBody": "ProductCard-module-scss-module__RFMiWq__cardBody",
  "cardHeader": "ProductCard-module-scss-module__RFMiWq__cardHeader",
  "green": "ProductCard-module-scss-module__RFMiWq__green",
  "largeProductCard": "ProductCard-module-scss-module__RFMiWq__largeProductCard",
  "orange": "ProductCard-module-scss-module__RFMiWq__orange",
  "smallProductCard": "ProductCard-module-scss-module__RFMiWq__smallProductCard",
  "statusRibbon": "ProductCard-module-scss-module__RFMiWq__statusRibbon",
});
